module.exports = __webpack_public_path__ + "img/logo_he.8f205d4.svg";